import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './FallBackSidebar.module.scss';

interface IFallbackComponent {
	onResetError: () => void;
}

const FallBackSidebar: React.FC<IFallbackComponent> = ({ onResetError }) => {
	return (
		<div className={style.container} data-test="FallBackSidebar">
			<svg className={style.icon}>
				<use xlinkHref={`${breadcrumbs}#errorBoundary`} />
			</svg>
			<Text
				className={style.title}
				translationNameSpace="error"
				translationKey="errorBoundaryTitle"
				theme="accent"
				size="xxl"
			/>
			<Text
				className={style.text}
				translationNameSpace="error"
				translationKey="errorBoundaryText"
				theme="contrast"
				align="center"
			/>
			<div>
				<Button
					className={style.retryBtn}
					theme="primaryBlue"
					onClick={onResetError}
					icon={
						<svg>
							<use xlinkHref={`${breadcrumbs}#reload`} />
						</svg>
					}>
					<Text translationNameSpace="error" translationKey="retryButton" asFragment={true} />
				</Button>
			</div>
		</div>
	);
};

export default FallBackSidebar;
